import { computed } from 'vue'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'
import { getWorkspaceAccentStyle } from '@/utils/workspaceColor'

/**
 * CSS variables --ws-cli-accent* a partir de currentWorkspace.corWorkspace.
 */
export function useWorkspaceAccentStyle () {
  const { currentWorkspace } = useGlobalWorkspaces()

  const workspaceAccentStyle = computed(() =>
    getWorkspaceAccentStyle(currentWorkspace.value?.corWorkspace)
  )

  return { workspaceAccentStyle }
}
